import React, { useEffect, useRef, useState } from "react";
import { db } from "MY_LOGIN_AND_SIGNUP/db/config";
import {
    Button,
    Table,
    Col,
    Input,
    Row,
    Modal,
    ModalBody,
} from 'reactstrap';
import firebase from "firebase";
import { Delete } from "@mui/icons-material";
import SearchIcon from '@mui/icons-material/Search';
import NotificationAlert from 'react-notification-alert';
import DeleteIncompleteStudent from "./DeleteIncompleteStudent";

const IncompleteStudents = () => {
    const functions = firebase.functions();
    const [userData, setUserData] = useState([]);
    const [SearchString, setSearchString] = useState('');
    const [SearchedRecords, setSearchedRecords] = useState([]);
    const [incompleteDeleteModal, setIncompleteDeleteModal] = useState(false);
    const [currentIncompleteUid, setCurrentIncompleteUid] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isBulkDelete, setIsBulkDelete] = useState(false);
    const [bulkDeleteModal, setBulkDeleteModal] = useState(false);

    const notifi = useRef();

    const notify = (msg, err) => {
        let color = err == false ? 'success' : 'danger';
        let options = {
            type: color,
            place: 'tr',
            message: (
                <div>
                    <div>
                        <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
                    </div>
                </div>
            ),
            icon: 'tim-icons icon-bell-55',
            autoDismiss: 6,
        };
        if (notifi.current) {
            notifi.current.notificationAlert(options);
        }
    };

    const incompleteStudentSearch = async (string) => {
        try {
            const stringTrim = string.trim()
            const result = userData.filter((user) => {
                return user?.email?.includes(stringTrim) || user?.phoneNumber?.includes(stringTrim);
            });
            if (result.length === 0) return notify("No matching records found. Please try a different search.");
            setSearchedRecords(result)
        } catch (error) {
            console.error("Error fetching data: ", error);
        }
    };

    const handleDelete = async (uid) => {
        try {
            document.querySelector('#loading-indicator').style.display = 'flex';
            const deleteUser = functions?.httpsCallable("deleteIncompleteUser");
            const response = await deleteUser({ uid });
            if (response.data.success) {
                setUserData((prevData) => prevData.filter((user) => user.uid !== uid));
                setSearchedRecords((prev) => prev.filter((user) => user.uid !== uid));
                notify("User has been deleted.", false);
            } else {
                notify("Failed to delete user. Please try again later.", true);
            }
        } catch (error) {
            console.error("Delete failed:", error);
            alert("Failed to delete user.");
        } finally {
            document.querySelector('#loading-indicator').style.display = 'none';
        }
    };

    const handleBulkDelete = async () => {
        try {
            document.querySelector('#loading-indicator').style.display = 'flex';
            const deleteUser = functions?.httpsCallable("deleteIncompleteUser");

            for (const uid of selectedUsers) {
                await deleteUser({ uid });
            }

            setUserData(prev => prev.filter(user => !selectedUsers.includes(user.uid)));
            setSearchedRecords(prev => prev.filter(user => !selectedUsers.includes(user.uid)));
            setSelectedUsers([]);
            notify("Selected users have been deleted.", false);
        } catch (error) {
            console.error("Bulk delete failed:", error);
            notify("Failed to delete selected users.", true);
        } finally {
            setIsBulkDelete(false);
            document.querySelector('#loading-indicator').style.display = 'none';
        }
    };

    const handleCheckboxChange = (uid) => {
        setSelectedUsers((prev) =>
            prev.includes(uid)
                ? prev.filter((id) => id !== uid)
                : [...prev, uid]
        );
    };

    const isAllSelected = () => {
        const currentList = SearchedRecords.length > 0 ? SearchedRecords : userData;
        return selectedUsers.length === currentList.length;
    };

    const handleSelectAll = () => {
        const currentList = SearchedRecords.length > 0 ? SearchedRecords : userData;
        if (isAllSelected()) {
            setSelectedUsers([]);
        } else {
            setSelectedUsers(currentList.map(user => user.uid));
        }
    };

    const fetchData = async () => {
        try {
            document.querySelector('#loading-indicator').style.display = 'flex';
            const incompleteStudent = functions.httpsCallable('listIncompleteUsers');
            const fetchdata = await incompleteStudent({});
            setUserData(fetchdata.data.inactiveUser);
        } catch (error) {
            console.error("Error fetching data: ", error);
        } finally {
            document.querySelector('#loading-indicator').style.display = 'none';
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        setIsBulkDelete(selectedUsers.length > 0);
    }, [selectedUsers]);

    const renderUsers = SearchedRecords.length > 0 ? SearchedRecords : userData;

    return (
        <div>
            <NotificationAlert ref={notifi} />
            <Modal isOpen={incompleteDeleteModal} style={{ maxWidth: 'auto' }}>
                <ModalBody>
                    <DeleteIncompleteStudent
                        deleteIncompleteStu={() => handleDelete(currentIncompleteUid)}
                        setIncompleteDeleteModal={setIncompleteDeleteModal}
                    />
                </ModalBody>
            </Modal>

            <Modal isOpen={bulkDeleteModal} style={{ maxWidth: 'auto' }}>
                <ModalBody>
                    <DeleteIncompleteStudent
                        deleteIncompleteStu={handleBulkDelete}
                        setIncompleteDeleteModal={setBulkDeleteModal}
                    />
                </ModalBody>
            </Modal>


            <Row className="align-items-center" style={{ marginBottom: '20px' }}>
                <Col sm={5} md={5} lg={4} >
                    <Input
                        type="text"
                        placeholder="Search Student"
                        onChange={(e) => {
                            setSearchString(e.target.value);
                            if (e.target.value.length === 0) setSearchedRecords([]);
                        }}
                    />
                </Col>

                <Col sm={2} md={2} lg={1} className="d-flex" style={{ paddingLeft: '0px' }}>
                    <Button
                        color="info"
                        className="me-2"
                        style={{ padding: '6px 10px', width: '100%' }}
                        onClick={() => {
                            if (SearchString.trim().length === 0) {
                                return notify("Please enter something to search", true);
                            }
                            incompleteStudentSearch(SearchString);
                        }}
                    >
                        <SearchIcon />
                    </Button>
                </Col>

                {isBulkDelete && (
                    <Col sm={5} md={5} lg={7}>
                        <div className="d-flex justify-content-end">
                            <Button
                                color="danger"
                                style={{ padding: '6px 10px', marginRight: '25px' }}
                                onClick={() => setBulkDeleteModal(true)}
                            >
                                <Delete />
                            </Button>
                        </div>
                    </Col>
                )}
            </Row>



            {userData.length > 0 ? (
                <Table className='tablesorter'>
                    <thead className='text-primary'>
                        <tr>
                            <th>
                                <input
                                    type='checkbox'
                                    checked={isAllSelected()}
                                    onChange={handleSelectAll}
                                />
                            </th>
                            <th>Email</th>
                            <th style={{ textAlign: 'center' }}>Mobile</th>
                            <th style={{ textAlign: 'center' }}>Provider</th>
                            <th style={{ textAlign: 'center' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderUsers.map((user) => (
                            <tr key={user.uid}>
                                <td>
                                    <input
                                        type='checkbox'
                                        checked={selectedUsers.includes(user.uid)}
                                        onChange={() => handleCheckboxChange(user.uid)}
                                    />
                                </td>
                                <td>{user.email || 'NA'}</td>
                                <td style={{ textAlign: 'center' }}>{user.phoneNumber || 'NA'}</td>
                                <td style={{ textAlign: 'center' }}>{user.providers === 'password' ? 'Email' : user.providers}</td>
                                <td style={{ textAlign: 'center' }}>
                                    <Delete
                                        style={{ color: 'red', cursor: 'pointer' }}
                                        onClick={() => {
                                            setIncompleteDeleteModal(true);
                                            setCurrentIncompleteUid(user.uid);
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <div style={{
                    textAlign: 'center',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    padding: '20px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    marginTop: '20px',
                }}>
                    No Pending Account Available
                </div>
            )}
        </div>
    );
};

export default IncompleteStudents;
